module.exports = require("redux");


//////////////////
// WEBPACK FOOTER
// external "redux"
// module id = 378
// module chunks = 0